import { render } from "./IpTrackerInput.vue?vue&type=template&id=0c82c083"
import script from "./IpTrackerInput.vue?vue&type=script&lang=ts"
export * from "./IpTrackerInput.vue?vue&type=script&lang=ts"
script.render = render

export default script